import React from "react";
import {menuData} from "../../assets/data/menu.data";
import vege from "../../img/small/vege.webp";
import FoodCardComponent from "../_shared/food-card/food-card.component";
import {useTranslation} from "react-i18next";
import {GiChiliPepper} from "react-icons/gi";

export default function MenuMenuComponent(props) {
    const {t} = useTranslation();

    return (
        <div className={props.class}>
            <div className="d-f-c-c">
                <div className="w-v-90">
                    <FoodCardComponent data={menuData.tapas} bh={props.bh} bt={props.bt} bb={props.bb}/>
                    <FoodCardComponent data={menuData.antipasti} bh={props.bh} bt={props.bt} bb={props.bb}/>
                    <FoodCardComponent data={menuData.pasta} bh={props.bh} bt={props.bt} bb={props.bb}/>
                    <FoodCardComponent data={menuData.insalata} bh={props.bh} bt={props.bt} bb={props.bb}/>
                    <FoodCardComponent data={menuData.specialita} bh={props.bh} bt={props.bt} bb={props.bb}/>
                    <FoodCardComponent data={menuData.pizze} bh={props.bh} bt={props.bt} bb={props.bb}/>
                    <FoodCardComponent data={menuData.dessert} bh={props.bh} bt={props.bt} bb={props.bb}/>

                    <div className="flex items-center justify-center gap-4">
                        <span className="flex item-center justify-center gap-2">
                          <img src={vege} alt="Végétarien" className="min-h-5 min-w-5 h-5 w-5"/>

                          <h4>{t("MENU.VEG")}</h4>
                        </span>

                        <span className="flex item-center justify-center gap-2">
                          <GiChiliPepper style={{color: "red"}} className="min-h-5 min-w-5 h-5 w-5"/>

                          <h4>{t("MENU.SPICY")}</h4>
                        </span>
                    </div>

                    <p className="mt-4 text-center text-xs">
                        {t("MENU.LEGAL_NOTICE")}
                    </p>
                </div>
            </div>
        </div>
    );
}
